import React, {useState, useEffect, Fragment} from 'react'
import {Table, Container, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {Channelselect} from '../channelselect';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {CanvasNavigation} from '../Navigation'
import {SortableList} from './sortable_list'
import _ from 'lodash'

export default function Eventlist(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    /*const existingStructure = useSelector(({canvas_structure}) => ({
            sport: Object.keys(canvas_structure.sport),
            category: Object.keys(canvas_structure.category),
            tournament: Object.keys(canvas_structure.tournament)
        }));*/

    const channel = (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?props.match.params.channel:null;
    const sport = (typeof props.match.params.sport !== 'undefined' && props.match.params.sport.length > 0)?props.match.params.sport:null;
    const category = (typeof props.match.params.category !== 'undefined' && props.match.params.category.length > 0)?props.match.params.category:null;
    const tournament = (typeof props.match.params.tournament !== 'undefined' && props.match.params.tournament.length > 0)?props.match.params.tournament:null;

    const items = useSelector(({canvas_structure}) => {
        if(category !== null)
            return canvas_structure.tournament;
        if(sport !== null)
            return canvas_structure.cis;
        if(channel !== null)
            return canvas_structure.sport;
        
        return null;
    });

    const path = useSelector(({canvas_structure}) => {
        let ret = [];

        if(sport !== null && typeof canvas_structure.sport[sport] !== 'undefined')
            ret.push(canvas_structure.sport[sport])
        if(category !== null && typeof canvas_structure.cis[category] !== 'undefined')
            ret.push(canvas_structure.cis[category])
        if(tournament !== null && typeof canvas_structure.tournament[tournament] !== 'undefined')
            ret.push(canvas_structure.tournament[tournament])
        return ret;
    });

    const cis = useSelector(({canvas_structure}) => {
        if(category !== null && typeof canvas_structure.cis[category] !== 'undefined')
            return canvas_structure.cis[category];
        return null;
    });

    const mode = (category !== null)
                    ?'tournament'
                    :(sport !== null)
                        ?'cis'
                        :(channel !== null)
                            ?'sport'
                            :'channel';

    useEffect(() => {
        if(channel !== null)
            dispatch(StructureActions.loadSports(firestore, channel));
        
    }, [channel]);

    useEffect(() => {
        if(sport !== null)
            dispatch(StructureActions.loadCis(firestore, channel, sport));
        
    }, [sport]);

    useEffect(() => {
        if(category !== null && cis !== null){
            console.log(cis.category_uid);
            dispatch(StructureActions.loadTournaments(firestore, channel, sport, cis.category_uid));
        }
        
    }, [category]);

    const open = (id) => {
        let p = [channel];
        if(sport !== null)
            p.push(sport);
        if(category !== null)
            p.push(category);
        if(tournament !== null)
            p.push(tournament);
        p.push(id);

        dispatch(RouterActions.push('canvas/structure/' + p.join('/')));
    }

    let sorted = [];

    if(typeof items !== 'undefined' && items !== null){
        let clonedItems = _.cloneDeep(items);
        sorted = Object.values(clonedItems);

        //Sort by name
        sorted.sort((a, b) => {
            let nameA = (typeof a.name !== 'undefined')
                        ?a.name
                        :(typeof a.canvas !== 'undefined' && typeof a.canvas.name !== 'undefined')
                            ?a.canvas.name
                            :(typeof a.canvas.canvas !== 'undefined')
                                ?a.canvas.canvas.name
                                :null;
            let nameB = (typeof b.name !== 'undefined')
                        ?b.name
                        :(typeof b.canvas !== 'undefined' && typeof b.canvas.name !== 'undefined')
                            ?b.canvas.name
                            :(typeof b.canvas.canvas !== 'undefined')
                                ?b.canvas.canvas.name
                                :null;

            return nameA.localeCompare(nameB);
        });

        //Set default sort index of all items and reference to prev. element
        for(let idx in sorted){
            let item = sorted[idx];

            if(typeof item.structure === 'undefined')
                item.structure = {after: null};
            
            item.structure.index = idx + 1; //Start by 1 so that an item with is-first gets index 0

            if(item.structure.after !== null)
                if(typeof clonedItems[item.structure.after] !== 'undefined')
                    item.structure.after = clonedItems[item.structure.after];
                else
                    item.structure.after = null;
            
            if(typeof item.structure['is-first'] !== 'undefined' && item.structure['is-first'])
                item.structure.index = 0;

            item.structure.subindex = 0;
        }

        //Update index of rearranged items
        for(let item of sorted){
            if(item.structure.after !== null){
                let idx = item.structure.index;

                let el = item;
                do{
                    el = el.structure.after;
                }while(el.structure.after !== null);

                item.structure.subindex = el.structure.index;
                item.structure.index = el.structure.index;
            }
        }

        sorted.sort((a, b) => {
            if(a.structure.index !== b.structure.index)
                return a.structure.index - b.structure.index;
            
            return a.structure.subindex - b.structure.subindex;
        });
    }

    const onSortEnd = ({oldIndex, newIndex}) => {
        
        let item = sorted[oldIndex].uid;

        /*if(newIndex !== 0){
            let after = sorted[newIndex - 1].uid;
            let replaces = sorted[newIndex].uid;
            dispatch(StructureActions.setAfter(item, after));
        }else{
            dispatch(StructureActions.setFirst(item, sorted[0].uid));
        }*/

        //dispatch(StructureActions.rearrange())
    }

    return (
        <CanvasNavigation breadcrumb={[
            {
                'caption': 'Struktur',
                'href': 'canvas/structure/'
            },
            ...(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?[{            
                'caption': props.match.params.channel,
                'href': 'canvas/structure/' + props.match.params.channel
            }]:[],
            ...(path.map((p, idx) => {
                let r = [channel];

                if(typeof p === 'undefined')return null;

                for(let i = 0;i <= idx; i++){
                    if(typeof path[i] !== 'undefined')
                        r.push(path[i].uid);
                }

                return {
                    'caption': (typeof p.name !== 'undefined')
                        ?p.name
                        :(typeof p.canvas !== 'undefined' && typeof p.canvas.name !== 'undefined')
                            ?p.canvas.name
                            :(typeof p.canvas.canvas !== 'undefined')
                                ?p.canvas.canvas.name
                                :p.uid,
                    'href': 'canvas/structure/' + r.join('/')
                }
            }))
        ]}>
            <div>
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?null
                    :<Channelselect onChannelSelect={(channelId) => {
                        dispatch(RouterActions.push('canvas/structure/' + channelId));
                    }} />
                }
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?
                        <div>
                            <Container fluid style={{
                                padding: "20px",
                                overflow: 'auto'
                            }}>
                                <SortableList release={(id) => {
                                    //release(id, this.props.channel, this.props.lottery);
                                }} lockAxis="y" edit={(e) => {}} items={sorted} mode={mode} open={(id) => open(id)} useDragHandle={true} onSortEnd={onSortEnd} editMarkets={(sportUid) => {
                                    dispatch(RouterActions.push('canvas/markets/' + props.match.params.channel + '/' + sportUid));
                                }} />

                            </Container>
                        </div>
                    :null
                }
            </div>
        </CanvasNavigation>
    );
}